import { render, staticRenderFns } from "./KoioteSnap7ConnectionProperties.vue?vue&type=template&id=15b62aac&lang=es"
import script from "./KoioteSnap7ConnectionProperties.vue?vue&type=script&lang=js"
export * from "./KoioteSnap7ConnectionProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports